"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultClass = exports.classNumMax = exports.classNumMin = void 0;
exports.classNumMin = 0;
exports.classNumMax = 12;
const getDefaultClass = () => ({
    id: "",
    labels: [],
    text: "",
    originalHref: "",
    originalScheduleURI: "",
    fullClassOrig: "",
    classNumOrig: "",
    classCharOrig: "",
    fullClass: "",
    classNum: 0,
    classChar: "",
    lessons: [],
});
exports.getDefaultClass = getDefaultClass;
//# sourceMappingURL=Class.js.map